class Account {
  constructor(model) {
    const {name, subdomain, permissions, roles} = Account.convertAccountDTOtoModel(model);

    const domain = process.env.NEXT_PUBLIC_SHIELD_OUTBOUND_URL;
    const base = `https://${subdomain}.${domain}`;

    this.name = name;
    this.subdomain = subdomain;
    this.permissions = permissions;
    this.roles = roles;
    this.dashboardUrl = `${base}/backend/home`;
    this.settingsUrl = `${base}/backend/settings/user`;
  }

  static convertAccountDTOtoModel = ({acc_name, acc_subdomain, permissions, roles} = {}) => ({
    name: acc_name,
    subdomain: acc_subdomain,
    permissions,
    roles
  });
}

export default Account;
